import {BaseView} from "../core/view"
import "bootstrap-slider"

export default BaseView.extend({

    minLabelElement: undefined,
    maxLabelElement: undefined,
    minValue: undefined,
    maxValue: undefined,
    initialMinValue: undefined,
    initialMaxValue: undefined,
    currency: undefined,
    prefixCurrency: false,
    url: undefined,
    goToUrl: undefined,
    initialActiveFilters: undefined,

    events: {
        'slide': 'updateLabels',
        'slideStop': 'validateFilterPrices',
        'click' : 'stopPropagation',
        'change .js-price-input-min': 'validateFilterPrices',
        'change .js-price-input-max': 'validateFilterPrices'
    },
    
    templates: {
        PRICE_FILTER_TEMPLATE: require("./templates/mobile-price-filter-template.hbs"),
    },
    
    stopPropagation: function(e) {
        e.stopPropagation();
    },

    updateLabels: function(e) {
        this.minLabelElement.val(e.value[0]);
        this.maxLabelElement.val(e.value[1]);
    },
    
    clearFilter: function(e) {
        this.$el.find('[data-bind=priceslider]').slider('setValue', [this.initialMinValue, this.initialMaxValue]);
        this.minLabelElement.val(this.initialMinValue);
        this.maxLabelElement.val(this.initialMaxValue);
    },
    
    setActiveFilters: function(){
        var priceFilterEnabled = (this.initialActiveFilters.priceMin.length > 0 || this.initialActiveFilters.priceMax.length > 0);
        var minPrice = this.initialActiveFilters.priceMin.length > 0 ? this.initialActiveFilters.priceMin[0].filterValue : this.initialMinValue;
        var maxPrice = this.initialActiveFilters.priceMax.length > 0 ? this.initialActiveFilters.priceMax[0].filterValue : this.initialMaxValue;
        if (priceFilterEnabled){
            this.$el.find('[data-bind=priceslider]').slider('setValue', [minPrice, maxPrice]);
            this.minLabelElement.val(minPrice);
            this.maxLabelElement.val(maxPrice);
            var data = {
                filterType : 'price',
                filterPriceMin: minPrice,
                filterPriceMax: maxPrice,
                filterCurrency: this.currency,
                prefixCurrency: this.prefixCurrency
            };
            Backbone.trigger('applyMobilePriceFilter',data);
        }
    },
    
    activateFilter: function(){
        
        var minInput = parseInt(this.minLabelElement.val()),
        maxInput = parseInt(this.maxLabelElement.val()),
        priceFilterString = "";
        
        if ((minInput != this.initialMinValue)||(maxInput!=this.initialMaxValue)) {
            var data = {
                filterType : 'price',
                filterPriceMin: minInput,
                filterPriceMax: maxInput,
                filterCurrency: this.currency,
                prefixCurrency: this.prefixCurrency
            };
            Backbone.trigger('applyMobilePriceFilter',data);
        }else{
            var data = {
                filterType : 'price',
                filterPriceDelete: true
            };
            Backbone.trigger('applyMobilePriceFilter',data);
        }
    },
    
    validateFilterPrices: function() {
        var minInput = parseInt(this.minLabelElement.val()),
        maxInput = parseInt(this.maxLabelElement.val());
        
        if (minInput < this.minValue){
            minInput = this.minValue;
        }
        if (minInput >= this.maxValue){
            minInput = this.maxValue - 1;
        }
        if (maxInput <= this.minValue){
            maxInput = this.minValue + 1;
        }
        if (maxInput > this.maxValue){
            maxInput = this.maxValue;
        }
        if (maxInput <= minInput){
            maxInput = minInput+1;
        }
        if (minInput >= maxInput){
            minInput = maxInput-1;
        }
        this.minLabelElement.val(minInput);
        this.maxLabelElement.val(maxInput);
        this.$el.find('[data-bind=priceslider]').slider('setValue', [minInput, maxInput]);
        this.activateFilter();
    },

    initialize: function(options) {
        var priceData = options.filterData;
        var data = {
    		prefixCurrency: priceData.currencyIsPrefixed,
        	minLabelValue: priceData.min,
        	maxLabelValue: priceData.max,
        	currency: priceData.currency,
        	absoluteMin: priceData.filterMin,
        	absoluteMax: priceData.filterMax,
            priceFilterSetted: (priceData.min > priceData.filterMin) || (priceData.max < priceData.filterMax)
        }
    	this.initialActiveFilters = options.initialActiveFilters;
    	this.$el.html(this.templates.PRICE_FILTER_TEMPLATE(data));
    	this.$el.find('[data-bind=priceslider]').slider();
        this.currency = data.currency;
        this.prefixCurrency = data.prefixCurrency;
        this.minLabelElement = this.$el.find('.js-price-input-min');
        this.maxLabelElement = this.$el.find('.js-price-input-max');
        this.initialMinValue = data.minLabelValue;
        this.initialMaxValue = data.maxLabelValue;
        this.minValue = data.absoluteMin;
        this.maxValue = data.absoluteMax;
        this.setActiveFilters();
    }
});
